import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const Heading = ({ id, children }) => {
  const keyName = id || children.trim();
  const ref = useRef(null);
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;

    if (hash && hash === `#${keyName}`) {
      const content = document.getElementsByClassName('content')[0];
      content.scrollTop = ref.current.offsetTop - 10;
    }
  }, [location, keyName])

  return (
    <h2 id={keyName} className="heading" ref={ref}>
      {children}
    </h2>
  )
}

export default Heading;
